<template>
  <div style="margin-left: 40px;margin-right: 40px;">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div class="card-left">
              <div class="card-left-up"><i class="fa fa-align-justify"></i> 商品规格模版</div>
            </div>
            <div class="cart-right">
              <div >
                <i class="fa fa-plus-square-o otbtn curpointer" v-on:click= "addspectempform()"> 添加</i>
                <i class="fa fa-save otbtn curpointer" v-on:click="savespectempdata()"> 保存</i>
                <i class="fa fa-rotate-right otbtn curpointer" v-on:click="refreshspectemp()"> 刷新</i>
              </div>
            </div>

          </div>
          <div class="note">
            <el-table
              :data="tableData"
              v-loading="tdloading"
              ref="multipleTable"
              highlight-current-row
              @current-change="handleSelectionChange">
              <el-table-column
                prop="specTmpName"
                label="模版名称"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="140px"
              >
                <template slot-scope="scope" class="opicondiv">
                  <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="editspectmp(scope.$index, tableData)"> 编辑 </i>
                  <i class="fa fa-trash-o opicon curpointer" v-on:click="removespectmp(scope.$index, tableData)"> 删除 </i>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog title="添加商品规格模版" :visible.sync="addspectempvis">
              <el-form :model="addspectemp">
                <el-form-item label="模版名称" :label-width="formLabelWidth">
                  <el-input v-model="addspectemp.name"  auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="addspectempvis = false">取 消</el-button>
                <el-button type="primary" @click="add_spectemp">确 定</el-button>
              </div>
            </el-dialog>
            <el-dialog title="编辑商品规格模版" :visible.sync="editspectempvis">
              <el-form :model="editspectemp">
                <el-form-item label="模版名称" :label-width="formLabelWidth">
                  <el-input v-model="editspectemp.name"  auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="editspectempvis = false">取 消</el-button>
                <el-button type="primary" @click="edit_spectemp">确 定</el-button>
              </div>
            </el-dialog>
            <el-pagination
              ref="elpage"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[size]"
              :page-size=size
              layout="total, sizes, prev, pager, next, jumper"
              :total=total>
            </el-pagination>

          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
    <div class="row">
      <div class="col-sm-6 col-lg-6">
        <div class="card-header">
          <div class="card-left">
            <div class="card-left-up"><i class="fa fa-align-justify"></i> 添加属性到右侧</div>
          </div>
          <div class="attrcart-left">
            <div >
              <i class="fa fa-plus-square-o otbtn curpointer" v-on:click="append()"></i>
              <i class="fa fa-save otbtn curpointer" v-on:click="save()"></i>
              <i class="fa fa-rotate-right otbtn curpointer" v-on:click="refresh()"></i>
              <i class="fa fa-angle-double-right otbtn curpointer" v-on:click="refresh()"></i>
            </div>
          </div>

        </div>
        <el-table
          :data="attrtableData"
          ref="multipleTable"
          @selection-change="attrselectchange">
          <el-table-column
            type="selection">
          </el-table-column>
          <el-table-column
            prop="name"
            label="属性"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="100px"
          >
            <template slot-scope="scope" >
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="edit(scope.$index, tableData)"></i>
              <i class="fa fa-trash-o opicon curpointer" v-on:click="remove(scope.$index, tableData)"></i>
              <i class="fa fa-angle-right opicon curpointer" v-on:click="remove(scope.$index, tableData)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div><!--/.col-->

      <div class="col-sm-6 col-lg-6">
        <div class="card-header">
          <div class="card-left">
            <div class="card-left-up"><i class="fa fa-align-justify"></i> 选择模版并添加(>)属性</div>
          </div>
          <div class="attrcart-right">
            <div >
              <i class="fa fa-save otbtn curpointer" v-on:click="save()"></i>
              <i class="fa fa-rotate-right otbtn curpointer" v-on:click="refresh()"></i>
            </div>
          </div>

        </div>
        <el-table
          :data="specattrtableData"
          ref="multipleTable">
          <el-table-column
            prop="name"
            label="属性"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="80px"
          >
            <template slot-scope="scope" class="opicondiv">
              <i class="fa fa-trash-o opicon curpointer" v-on:click="remove(scope.$index, tableData)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div><!--/.col-->

    </div>
  </div>

</template>
<script>
var that
var curpagedata
var curdata
var curattrdata
var curtmpattrdata
export default {
  name: 'GoodsBrand',
  created: function () {
    console.log('开始创建')
    that = this
    that.size = 5
    var goodsspectemp = JSON.parse(localStorage.getItem('goodsspectemp'))
    if (goodsspectemp === null) {
      console.log('开始读取网络数据')
      that.$http.post('https://api.sqnetsoft.cn/goods/find_goodsspectemp', {
        qstr: 'id>0'
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success === true) {
            console.log(res.data.data[0])
            console.log(JSON.stringify(res.data.data))
            localStorage.setItem('goodsspectemp', JSON.stringify(res.data.data))
            curdata = JSON.parse(localStorage.getItem('goodsspectemp'))
            curpagedata = new Array(that.size)
            console.log(curdata)
            curpagedata.splice(0, that.size)
            that.total = curdata.length
            for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
              if (curdata[i] != null) {
                curpagedata.push(curdata[i])
              }
            }
            that.tableData = JSON.parse(JSON.stringify(curpagedata))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    } else {
      console.log('从本地读取')
      var goodsbrandstate = localStorage.getItem('goodsspectempstate')
      if (goodsbrandstate === '0') {
        that.$message({
          type: 'info',
          message: '您上次保存失败，请重新保存！'
        })
      }
      curpagedata = new Array(this.size)
      curdata = JSON.parse(localStorage.getItem('goodsspectemp'))
      curpagedata.splice(0, this.size)
      that.total = curdata.length
      for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
      that.tableData = JSON.parse(JSON.stringify(curpagedata))
    }
    // 读取所有商品属性
    var goodsattrtemp = JSON.parse(localStorage.getItem('goodsattr'))
    if (goodsattrtemp === null) {
      console.log('开始读取网络数据')
      that.$http.post('https://api.sqnetsoft.cn/goods/find_goodsbaseattr', {
        qstr: 'id>0'
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success === true) {
            console.log(JSON.stringify(res.data.data))
            localStorage.setItem('goodsattr', JSON.stringify(res.data.data))
            that.attrtableData = JSON.parse(JSON.stringify(res.data.data))
            curattrdata = JSON.parse(JSON.stringify(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    } else {
      console.log('从本地读取')
      var goodsattrstate = localStorage.getItem('goodsattrstate')
      if (goodsattrstate === '0') {
        that.$message({
          type: 'info',
          message: '您上次保存失败，请重新保存！'
        })
      }
      that.attrtableData = JSON.parse(localStorage.getItem('goodsattr'))
      curattrdata = JSON.parse(localStorage.getItem('goodsattr'))
    }
    // 读取所有商品属性
    var goodsstatemp = JSON.parse(localStorage.getItem('goodssta'))
    if (goodsstatemp === null) {
      console.log('开始读取网络数据')
      that.$http.post('https://api.sqnetsoft.cn/goods/find_goodsSTA', {
        qstr: 'id>0'
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success === true) {
            console.log(JSON.stringify(res.data.data))
            localStorage.setItem('goodssta', JSON.stringify(res.data.data))
            curtmpattrdata = JSON.parse(localStorage.getItem('goodssta'))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    } else {
      console.log('从本地读取')
      var goodsstastate = localStorage.getItem('goodsstastate')
      if (goodsstastate === '0') {
        that.$message({
          type: 'info',
          message: '您上次保存失败，请重新保存！'
        })
      }
      curtmpattrdata = JSON.parse(localStorage.getItem('goodssta'))
    }
  },
  mounted: function () {
    console.log('mounted')
    if (curdata) {
      that.$refs.elpage.count = 0
    } else {
      that.$refs.elpage.count = curdata.length
    }
  },
  data () {
    return {
      tableData: [],
      deltdrec: [],
      attrtableData: [],
      specattrtableData: [],
      querystr: '',
      tdloading: false,
      dialogTableVisible: false,
      addspectempvis: false,
      editspectempvis: false,
      addattrvis: false,
      editattrvis: false,
      addspectemp: {
        name: ''
      },
      editspectemp: {
        id: '',
        name: ''
      },
      addattr: {
        name: ''
      },
      editattr: {
        id: '',
        name: ''
      },
      formLabelWidth: '80px',
      currentPage: 1,
      total: 0,
      curpage: 1,
      size: 5,
      curindex: 0
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log('每页' + val + '条')
    },
    handleCurrentChange (val) {
      console.log('当前页: ' + val)
      this.curpage = val
      curpagedata.splice(0, this.size)
      for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
      that.tableData = JSON.parse(JSON.stringify(curpagedata))
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      console.log(val)
      var flselect = []
      var localgoodssta = JSON.parse(localStorage.getItem('goodssta'))
      for (var i = 0; i < localgoodssta.length; i++) {
        if (val !== null) {
          if (localgoodssta[i].specTmpId === val.id) {
            flselect.push(localgoodssta[i])
          }
        }
      }
      that.specattrtableData = JSON.parse(JSON.stringify(flselect))
    },
    attrselectchange (val) {
      console.log('attr select change')
      console.log(val)
    },
    addspectempform () {
      // 清空数据
      this.addspectemp.name = ''
      this.addspectempvis = true
    },
    add_spectemp () {
      // 获取添加的数据
      var adata = {id: null, specTmpName: this.addspectemp.name}
      // 插入最后一行
      curdata.splice(0, 0, adata)
      // ********重新做分页处理********
      // 重新构建当前页面数据，并清空页面数据
      if (!curpagedata) {
        curpagedata = new Array(that.size)
      }
      curpagedata.splice(0, that.size)
      // 获取当前页面数据
      for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
      // 将获取到的页面数据更新到表
      that.tableData = JSON.parse(JSON.stringify(curpagedata))
      // 更新记录数
      that.$refs.elpage.count = curdata.length
      this.total = curdata.length
      // 把添加后的数据重新缓存到本地
      localStorage.setItem('goodsspectemp', JSON.stringify(curdata))
      // 关闭页面
      this.addspectempvis = false
      this.$message({
        type: 'success',
        message: '已添加商品模版'
      })
    },
    edit_spectemp () {
      console.log('edit form start')
      if (this.editspectemp.id === null) {
        // 隐藏编辑页面
        this.editspectempvis = false
        this.$message({
          type: 'error',
          message: '未保存数据无法编辑'
        })
      } else {
        // 获取新的编辑数据
        var adata = {id: this.editspectemp.id, specTmpName: this.editspectemp.name}
        // 替换数据
        curdata.splice(this.curindex, 1, adata)
        // ********重新做分页处理********
        // 重新构建当前页面数据，并清空页面数据
        if (!curpagedata) {
          curpagedata = new Array(that.size)
        }
        curpagedata.splice(0, that.size)
        // 获取当前页面数据
        for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
          if (curdata[i] != null) {
            curpagedata.push(curdata[i])
          }
        }
        // 将获取到的页面数据更新到表
        that.tableData = JSON.parse(JSON.stringify(curpagedata))
        // 更新记录数
        that.$refs.elpage.count = curdata.length
        this.total = curdata.length
        // 把删除后的数据重新缓存到本地
        localStorage.setItem('goodsspectemp', JSON.stringify(curdata))
        // 隐藏编辑页面
        this.editspectempvis = false
        // 提示已经更新数据
        this.$message({
          type: 'success',
          message: '已更新规格模版'
        })
      }
    },
    savespectempdata () {
      console.log('save')
      this.$http.post('https://api.sqnetsoft.cn/goods/p_add_goodsspectemp', curdata, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success === true) {
            that.$message({
              type: 'success',
              message: res.data.data
            })
            localStorage.setItem('goodsspectempstate', 1)
            localStorage.setItem('goodsspectemp', JSON.stringify(curdata))
          } else {
            that.$message({
              type: 'info',
              message: res.data.data
            })
            localStorage.setItem('goodsspectempstate', 0)
            localStorage.setItem('goodsspectemp', JSON.stringify(curdata))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      if (that.deltdrec.length > 0) {
        var delstr = 'id in ('
        for (var z = 0; z < that.deltdrec.length; z++) {
          var dataindex = curdata.findIndex(d => d.id === that.deltdrec[z].id)
          // 移除该条数据
          curdata.splice(dataindex, 1)
          delstr = delstr + "'" + that.deltdrec[z].id + "',"
        }
        delstr = delstr.substring(0, delstr.lastIndexOf(','))
        delstr += ')'
        console.log(delstr)
        that.tdloading = true
        this.$http.post('https://api.sqnetsoft.cn/goods/p_del_goodsspectemp', {
          conditionstr: delstr
        }, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success === true) {
              that.tdloading = false
              that.$message({
                type: 'success',
                message: '保存完毕'
              })
              localStorage.setItem('goodsbrandstate', 1)
              localStorage.setItem('goodsspectempstate', JSON.stringify(curdata))
            } else {
              that.tdloading = false
              that.$message({
                type: 'error',
                message: '保存失败'
              })
              localStorage.setItem('goodsbrandstate', 0)
              localStorage.setItem('goodsspectempstate', JSON.stringify(curdata))
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    refreshspectemp () {
      // 重新获取数据
      that.loading = true
      that.$http.post('https://api.sqnetsoft.cn/goods/find_goodsspectemp', {
        qstr: 'id>0' // 查询条件
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          if (res.data.success === true) {
            // 把获取到的网络数据缓存到本地数据
            that.loading = false
            localStorage.setItem('goodsspectemp', JSON.stringify(res.data.data))
            console.log('已缓存网络数据')
            // 把缓存数据读入内存
            curdata = JSON.parse(localStorage.getItem('goodsspectemp'))
            // 创建页面数据
            if (!curpagedata) {
              curpagedata = new Array(that.size)
            }
            curpagedata.splice(0, that.size)
            // 进行分页
            for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
              if (curdata[i] != null) {
                curpagedata.push(curdata[i])
              }
            }
            // 更新表数据
            that.tableData = JSON.parse(JSON.stringify(curpagedata))
            // 更新表数量
            that.total = curdata.length
            that.$message({
              type: 'success',
              message: '读取完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    editspectmp (index, data) {
      console.log('start edit')
      console.log(data)
      // 显示编辑页面
      this.editspectempvis = true
      // 获取当前选择数据
      var curselectdata = data[index]
      // 呈现当前选中数据
      console.log(curselectdata)
      console.log(curdata)
      console.log(curattrdata)
      console.log(curtmpattrdata)
      // 在数据中获取当前索引
      that.curindex = curdata.findIndex(d => d.id === curselectdata.id)
      // 赋值到当前编辑页面
      that.editspectemp.id = curselectdata.id
      that.editspectemp.name = curselectdata.specTmpName
    },
    removespectmp (index, data) {
      // 获取当前需要删除的数据
      var curselectdata = data[index]
      // 从数据源中查找该数据的索引
      var dataindex = curdata.findIndex(d => d.id === curselectdata.id)
      // 移除该条数据
      curdata.splice(dataindex, 1)
      that.deltdrec.push(curselectdata)
      // ********重新做分页处理********
      // 重新构建当前页面数据，并清空页面数据
      if (!curpagedata) {
        curpagedata = new Array(that.size)
      }
      curpagedata.splice(0, that.size)
      // 获取当前页面数据
      for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
      // 将获取到的页面数据更新到表
      that.tableData = JSON.parse(JSON.stringify(curpagedata))
      // 更新记录数
      that.$refs.elpage.count = curdata.length
      this.total = curdata.length
      // 把删除后的数据重新缓存到本地
      localStorage.setItem('goodsspectemp', JSON.stringify(curdata))
    },
    queryinfo () {
      // 如果当前页面数据不存在创建
      if (!curpagedata) {
        curpagedata = new Array(that.size)
      }
      // 清空页面数据
      curpagedata.splice(0, this.size)
      // 判断查询字符串是否为空，为空显示所有数据
      if (this.querystr === '') {
        // 根据所有数据进行分页
        for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
          if (curdata[i] != null) {
            curpagedata.push(curdata[i])
          }
        }
        that.$refs.elpage.count = curdata.length
        this.total = curdata.length
      } else {
        // 根据查询条件进行分页
        for (var j = 0; j < this.total; j++) {
          if (curdata[j] != null && curdata[j].name.indexOf(this.querystr) >= 0) {
            curpagedata.push(curdata[j])
          }
        }
        that.$refs.elpage.count = curpagedata.length
        this.total = curpagedata.length
      }
      // 把当前页面数据更新到表
      that.tableData = JSON.parse(JSON.stringify(curpagedata))
    }
  }
}

</script>
<style lang="css">
  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: #f9f9fa;
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid #e1e6ef;
  }
  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid #e1e6ef;
  }

  .card-left {
    flex: 1;
    display: flex;
    flex-flow: column;
  }
  .card-left-up {

  }
  .card-left-down {
    display: flex;
    flex-flow: column;
  }
  .cart-fg {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 1px;
    margin-right: 10px;
    background-color: #f1f1f1;
  }
  .cart-right {
    width:180px;
  }

  .attrcart-right {
    width:50px;
  }

  .attrcart-left {
    width:100px;
  }

  .subcard {
    width: 48%;
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid #e1e6ef;
  }

  /**功能区域**/
  .gnarea {
    width: 100%;
    background-color: #00bf8f;
    display:flex;
    flex-flow: row;
  }

  .querytxt {
    padding-top: 10px;
    padding-right: 20px;
    flex:1;

  }
  .querybtn {
    padding-right: 10px;
    float: right;
    flex:1;
  }

  .otbtn {
    margin-top: 5px;
    margin-right: 10px;
    flex:1;
  }
  .tbitem {
    text-align: center;
  }
  .card-header1{
    height: auto;
  }

  .opicondiv {
    display: flex;
    flex-flow: row;
    background-color: #00bf8f;
  }

  .opicon{
    flex: 1;
    padding-right: 10px;
  }

  .el-table td, .el-table th {
    padding: 2px 0;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
  }
  .resize-triggers {
    animation: 1ms resizeanim;
    visibility: hidden;
    opacity: 0;
  }

  table {
    font-size: 12px;
  }

  td, th {
    display: table-cell;

  }

  table tr {
    padding: 0px;
  }

  table th, table td {

  }

  /**表标题栏**/
  table th {
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .note {
    width: 99%;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 10px;
  }

  .slnote{
    width: 48%;
    margin-left: 0px;
    margin-right: 0px;
  }

  .srnote{
    width: 48%;
    margin-left: 0px;
    margin-right: 0px;
  }

  .curpointer{
    cursor: pointer;
  }

  .el-dialog__body {
    margin: 10px 20px 10px 20px;
    padding: 20px 30px;
    color: #f1f1f1;
    line-height: 24px;
    font-size: 14px;
    border:1px solid;
    border-radius:10px;
    -moz-border-radius:10px; /* Old Firefox */
  }

  .el-form-item {
    margin-bottom: 5px;
  }
  .el-form-item1 {
    margin-bottom: 0px;
  }

  .el-form-item__label {
    text-align: left;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #5a5e66;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-dialog__footer {
    padding: 10px 10px 10px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-dialog__header {
    padding: 15px 15px 10px;
    background-color: #0d8ddb;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #f0f0f0;
  }

  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border:1px solid;
    border-radius:10px;
    -moz-border-radius:10px; /* Old Firefox */
    box-sizing: border-box;
    width: 80%;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsSpec.vue